import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

import CatalogList from '../../../../components/home/CatalogList/CatalogList'
import Dropdown from '../../../../components/ui/Dropdown/Dropdown'
import InputWithSuggestion from '../../../../components/ui/InputWithSuggestion/InputWithSuggestion'

import shopsBanner from '../../../../assets/img/AdventureBg.webp'
import ZingIcon from '../../../../assets/img/zing-icon.svg'

//(Link)
export const StyledLink = styled.div`
  text-decoration: none;
  width: calc(25% - 1rem);
  height: 244px;
  margin: 0.5rem;
  cursor: pointer;

  ${media.lessThan('medium')`
      width: calc(33% - 1rem);
  `}

  ${media.lessThan('small')`
    width: calc(100% - 1rem);
    height: 100px;
    margin: 0.5rem;
    box-sizing: border-box;
    padding: 0px;
  `}
`

export const ErrorCard = styled.div`
  width: calc(33% - 1rem);
  height: 300px;
  margin: 0.5rem;

  background: linear-gradient(
      rgba(141, 122, 157, 0.4),
      rgba(141, 122, 157, 0.4)
    ),
    #f9f9f9;
  border-radius: var(--border-radius-card);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledBanner = styled.div.attrs(() => ({
  style: {
    background: `linear-gradient(
      to bottom right,
      rgba(231, 71, 94, 0.90) 0%,
      rgba(235, 118, 50, 0.90) 100%
    ), url('${shopsBanner}') top / cover no-repeat`,
  },
}))`
  width: 100%;
  height: 530px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 8, 0) 0%, #000000 158px);

  ${media.lessThan('small')`
    height: 450px;
    margin-top: -40px;
  `}
`

export const BannerContent = styled.div`
  width: 100%;
  max-width: 1024px;
  height: 430px;
  margin: 0 auto;

  display: flex;
  align-items: center;
`

export const BannerDescription = styled.div`
  width: 100%;
  padding: 0 1rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #ffffff;
`

export const Heading = styled.div`
  /* margin-top:  !important; */
  ${media.lessThan('large')`
    padding: 0 1.5rem;
  `}

  ${media.lessThan('small')`
    padding: 0 1rem;
  `}
`

export const Content = styled.div`
  margin-top: 4rem;
`

export const FormContainer = styled.div`
  display: flex;
  margin-top: -6rem;
  width: 75%;
  margin: auto;

  ${media.lessThan('small')`
    width: 100%;
    /* margin: 1rem; */
    flex-wrap: wrap;
    margin-top: -9rem;
  `}
`

export const StyledCatalogList = styled(CatalogList)`
  ${media.lessThan('large')`
    margin: 0 1rem;
    justify-content: space-around;
  `}

  ${media.lessThan('small')`
    flex-direction: column;
    color: unset;
    padding: 0;
    justify-content: space-between;
    margin: 1rem;
  `}
`

export const RewardsCatalogTitle = styled.h2`
  font-size: 2rem;
  margin: 0;
  text-transform: uppercase;
  text-align: center;

  ${media.lessThan('small')`
    font-size: 1.375rem;
  `}
`
export const StyledShopDineCard = styled.div`
  border-radius: var(--border-radius-card);
  height: 100%;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.8)),
    linear-gradient(rgba(141, 122, 157, 0.4), rgba(141, 122, 157, 0.4)),
    linear-gradient(#000000, #000000);
  display: flex;
  justify-content: center;
  align-items: center;

  ${props =>
    props.cardImageUrl &&
    css`
      background: linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)), linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000);
      backgroundSize: 'cover';
      backgroundPosition: 'center';
    `}

  ${media.lessThan('small')`
    display: block;
    background: unset;
    background-color: #fff;
  `}
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem 2.5rem;
  border-radius: var(--border-radius-card);
  color: #ffffff;
  text-align: center;
  z-index: 1;

  ${media.lessThan('small')`
    flex-direction: row;
    padding: 0;
    align-items: center;
    height: 100px;
    box-sizing: border-box;
    overflow: hidden;
  `}
`

export const LogoContainer = styled.div`
  ${media.lessThan('small')`
    width: 100px;
    padding: 0px;
    /* margin: 0; */
    margin-left: -1rem;

    ${props =>
      props.cardImageUrl &&
      css`
        background: linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)), linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000);
        backgroundSize: 'cover';
        backgroundPosition: 'center';
        border-top-left-radius: 0.3125rem;
        border-bottom-left-radius: 0.3125rem;
      `}
  `}
`

export const Logo = styled.img`
  border: 0px;
  border-radius: 0.3125rem;
  height: 3.6875rem;
  width: 3.6875rem;
  margin: 2rem auto;
  object-fit: contain;

  ${props =>
    props.src == null &&
    css`
      background-color: #000;
      border: 0px;
    `}

    ${media.lessThan('medium')`
    margin: 1rem auto;
  `}
  ${media.lessThan('small')`
    padding: auto;
    box-sizing: border-box;
    /* margin: auto; */
  `}
`

export const LogoFiller = styled.div`
  height: 3.6875rem;
  width: 3.6875rem;
  margin: 2rem auto;
  background-color: transparent;
  ${media.lessThan('medium')`
  margin: 1rem auto;
`}
`

export const Title = styled.h1`
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: 0.28px;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 0.28px;
  margin: 0;
  text-transform: uppercase;

  ${media.lessThan('small')`
    width: calc(100% - 100px - 1rem);
    text-align: left;
    color: var(--color-fg);
    padding-left: 1rem;
    box-sizing: border-box;
  `}
`

export const ZingIconComponent = styled.img.attrs({ src: ZingIcon })`
  margin-bottom: 1rem;

  ${media.lessThan('small')`
    flex: 0 0 auto;
    padding: 1.25rem;
    margin-bottom: 0;
  `}
`

export const CategorySelectContainer = styled.div`
  width: 50%;
  color: #fff !important;

  select {
    margin-left: 6rem;
    padding: 0;
    color: #fff !important;
  }

  ${media.lessThan('medium')`
    width:100%;
    margin-right:initial;
`}
`
export const StyledDropdown = styled(Dropdown)`
  select.form-control {
    color: black;
  }
  & option:not(:checked) {
    color: black;
  }
  & option {
    color: black !important;
  }
`

export const StyledInputWithSuggestion = styled(InputWithSuggestion).attrs({
  styleProps: { banner: true, left: true },
})`
  margin-right: 1rem;
`
